import { z } from 'zod';

export const HealthStatus = z.enum(['ok', 'degraded', 'down']);
export type HealthStatus = z.infer<typeof HealthStatus>;

export const HealthCheck = z.object({
  ok: z.boolean(),
  latency_ms: z.int().nullable().optional(),
  error: z.string().nullable().optional(),
});
export type HealthCheck = z.infer<typeof HealthCheck>;

export const Health = z.object({
  status: HealthStatus,
  version: z.string().optional(),
  checks: z.record(z.string(), HealthCheck).optional(),
});
export type Health = z.infer<typeof Health>;
